import { render, staticRenderFns } from "./UpmsUserAccessLog.vue?vue&type=template&id=fc4d0a60&"
import script from "./UpmsUserAccessLog.vue?vue&type=script&lang=js&"
export * from "./UpmsUserAccessLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports